import {
  BarChart3,
  Blocks,
  BookOpen,
  Bot,
  Building2,
  FileText,
  FlaskConical,
  Headset,
  KeyRound,
  LayoutDashboard,
  Mail,
  MessageSquare,
  Settings,
  Star,
  SwatchBook,
  Target,
  UserCog,
  Users,
  type LucideIcon,
} from 'lucide-react';
import { appRoutes } from '../app-routes';
import type { LaunchDarklyFlags } from '../types/launch-darkly';

export interface SidebarItem {
  id: string;
  label: string;
  icon: LucideIcon;
  to: string;
  external?: boolean;
  requiresFlag?: keyof LaunchDarklyFlags;
}
export interface SidebarSection {
  id: string;
  label: string;
  items: SidebarItem[];
}

export const SIDEBAR_SECTIONS: SidebarSection[] = [
  {
    id: 'data',
    label: 'Data',
    items: [
      { id: 'metrics', label: 'Overview', icon: LayoutDashboard, to: '/dashboard/metrics' },
      { id: 'tenants', label: 'Tenants', icon: Building2, to: '/dashboard/tenants' },
      { id: 'users', label: 'Users', icon: Users, to: '/dashboard/users' },
      {
        id: 'communications',
        label: 'Communications',
        icon: MessageSquare,
        to: '/dashboard/communications',
      },
    ],
  },
  {
    id: 'features',
    label: 'Features',
    items: [
      { id: 'acquire', label: 'Acquire', icon: Target, to: '/dashboard/acquire' },
      { id: 'engage', label: 'Engage', icon: Mail, to: `${appRoutes.ENGAGE_SETUP}/usage` },
      { id: 'measure', label: 'Measure', icon: BarChart3, to: '/dashboard/measure' },
      { id: 'reputation', label: 'Reputation', icon: Star, to: `${appRoutes.REPUTATION_SETUP}/usage` },
      { id: 'voice', label: 'Assist', icon: Headset, to: appRoutes.VOICE },
    ],
  },
  {
    id: 'developers',
    label: 'Developers',
    items: [
      { id: 'api-keys', label: 'API Keys', icon: KeyRound, to: '/dashboard/settings/api' },
      { id: 'branding', label: 'Branding', icon: SwatchBook, to: '/dashboard/settings/theme' },
      {
        id: 'data-integration',
        label: 'Data Integration',
        icon: FileText,
        to: '/dashboard/settings/data-integration',
      },
      {
        id: 'ai-tools',
        label: 'Agents',
        icon: Bot,
        to: appRoutes.AI_AGENTS,
        requiresFlag: 'enable-partner-mcp-authoring',
      },
      {
        id: 'agents',
        label: 'Agent builder',
        icon: Blocks,
        to: appRoutes.AGENTS,
        requiresFlag: 'enable-partner-agent-builder',
      },
      {
        id: 'testing',
        label: 'Testing',
        icon: FlaskConical,
        to: 'https://docs.embedreach.com/embeddable-ui/iframe/sandbox',
        external: true,
      },
      {
        id: 'guides',
        label: 'Guides',
        icon: FileText,
        to: 'https://docs.embedreach.com/samples/jwt-tokens',
        external: true,
      },
      {
        id: 'documentation',
        label: 'API Docs',
        icon: BookOpen,
        to: 'https://docs.embedreach.com/api-reference/introduction',
        external: true,
      },
    ],
  },
  {
    id: 'settings',
    label: 'Settings',
    items: [
      { id: 'profile', label: 'Profile', icon: Settings, to: '/dashboard/settings' },
      { id: 'team', label: 'Team', icon: UserCog, to: '/dashboard/settings/team' },
    ],
  },
];
